export enum PostValidationEvent {
    EVENTBUS_PREFIX = "item-post-validate-",
    POSTVALIDATE = "qpp.postValidate",
    VALIDATE_COMPLETE = "postValidateComplete"
}